import { Module } from '@nu-art/ts-common';
// TODO, add more shit to this module as I go
class ModuleFE_PathwayEditor_Class extends Module {
    editorContext = {};
    constructor() {
        super();
    }
    getViewedPathwayId = () => {
        return this.editorContext.viewedPathway;
    };
    setViewedPathwayId = (pathwayId) => {
        this.editorContext.viewedPathway = pathwayId;
    };
}
export const ModuleFE_PathwayEditor = new ModuleFE_PathwayEditor_Class();
//# sourceMappingURL=ModuleFE_PathwayEditor.js.map